/** Attributes that must not appear in the desktop top facet bar (only in their dedicated selector, e.g. Last Seen). */
const EXCLUDED_TOP_FILTER_ATTRIBUTES = new Set(['normalisedTitle', 'lastSeenMin']);

/**
 * Category colors for desktop filter bar (aligned with FilterCategoryButtons).
 * - Location: green
 * - Salary: blue (no pills in second row; salary is modal-only)
 * - Company: purple
 * - Job: orange
 */
export const TOP_FILTER_CATEGORY_COLORS = {
  /** Location category: remoteness, location */
  location:
    'bg-green-50 dark:bg-green-900/30 text-green-700 dark:text-green-300 border-green-300 dark:border-green-700',
  /** Salary category (used if any salary-related attributes ever appear in top row) */
  salary:
    'bg-blue-50 dark:bg-blue-900/30 text-blue-700 dark:text-blue-300 border-blue-300 dark:border-blue-700',
  /** Company category: companyId, companyIndustry */
  company:
    'bg-purple-50 dark:bg-purple-900/30 text-purple-700 dark:text-purple-300 border-purple-300 dark:border-purple-700',
  /** Job category: jobType, normalisedRoleLevel, requiredLanguages, benefits, etc. */
  job: 'bg-orange-50 dark:bg-orange-900/30 text-orange-700 dark:text-orange-300 border-orange-300 dark:border-orange-700',
} as const;

/** Excluded (negative filter) pill style - same in all categories. */
export const TOP_FILTER_EXCLUDED_COLOR =
  'bg-red-50 dark:bg-red-900/30 text-red-700 dark:text-red-300 border-red-300 dark:border-red-700';

/** Attribute -> category for pill colors. */
const ATTRIBUTE_TO_CATEGORY: Record<string, keyof typeof TOP_FILTER_CATEGORY_COLORS> = {
  remoteness: 'location',
  location: 'location',
  companyId: 'company',
  companyIndustry: 'company',
  jobType: 'job',
  normalisedRoleLevel: 'job',
  requiredLanguages: 'job',
  benefits: 'job',
  skillsAndTechnologies: 'job',
  field: 'job',
  educationLevel: 'job',
  peopleManagementTier: 'job',
};

export function getTopFilterColorClass(
  attribute: string,
  isExcluded: boolean
): string {
  if (isExcluded) return TOP_FILTER_EXCLUDED_COLOR;
  const category = ATTRIBUTE_TO_CATEGORY[attribute];
  return category ? TOP_FILTER_CATEGORY_COLORS[category] : 'bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300 border-gray-300 dark:border-gray-600';
}

/** Order for grouping active facets (matches TopFilters final display order). */
export const TOP_FILTER_ATTRIBUTE_ORDER = [
  'remoteness',
  'location',
  'jobType',
  'normalisedRoleLevel',
  'requiredLanguages',
  'field',
  'peopleManagementTier',
  'companyIndustry',
  'companyId',
] as const;

/** Order for building the raw facet list (matches TopFilters allFacetsRaw). */
export const ALL_TOP_FILTER_ATTRIBUTES_ORDER = [
  'remoteness',
  'location',
  'jobType',
  'normalisedRoleLevel',
  'companyIndustry',
  'companyId',
  'requiredLanguages',
  'benefits',
  'skillsAndTechnologies',
  'field',
  'educationLevel',
  'peopleManagementTier',
] as const;

export function shouldIncludeFacetInTopFilters(attribute: string): boolean {
  return !EXCLUDED_TOP_FILTER_ATTRIBUTES.has(attribute);
}








